ixModuleRouting("impactx.controlstructure", {
    "/editctu/:id": {
        template: "<ixa-ctu></ixa-ctu>",
        process: "ViewCtu",
        workspace: "admin",
    },
    "/editctt/:id": {
        template: "<ixa-ctt></ixa-ctt>",
        process: "ViewCtt",
        workspace: "admin",
    },
    "/editprj/:id": {
        template: "<ixa-prj></ixa-prj>",
        process: "ViewPrj",
        workspace: "admin",
    },
    "/editcrd/:id": {
        template: "<ixa-crd></ixa-crd>",
        process: "ViewCrd",
        workspace: "admin",
    },
    "/editpsp/:id": {
        template: "<ixa-psp></ixa-psp>",
        process: "ViewPsp",
        workspace: "admin",
    },
    "/editctrla/:id": {
        template: "<ixa-ctrl-a></ixa-ctrl-a>",
        process: "ViewCtrlA",
        workspace: "admin",
    },
    "/editctrlb/:id": {
        template: "<ixa-ctrl-b></ixa-ctrl-b>",
        process: "ViewCtrlB",
        workspace: "admin",
    },
    "/editctrlc/:id": {
        template: "<ixa-ctrl-c></ixa-ctrl-c>",
        process: "ViewCtrlC",
        workspace: "admin",
    },
    "/editctrld/:id": {
        template: "<ixa-ctrl-d></ixa-ctrl-d>",
        process: "ViewCtrlD",
        workspace: "admin",
    },
    "/editasn/:id": {
        template: "<ixa-asn></ixa-asn>",
        process: "ViewAsn",
        workspace: "admin",
    },
    "/editino/:id": {
        template: "<ixa-ino></ixa-ino>",
        process: "ViewIno",
        workspace: "admin",
    },
    "/editloc/:id": {
        template: "<ixa-loc></ixa-loc>",
        process: "ViewLoc",
        workspace: "admin",
    },
    "/editact/:id": {
        template: "<ixa-act></ixa-act>",
        process: "ViewAct",
        workspace: "admin",
    },
    "/editnet/:id": {
        template: "<ixa-net></ixa-net>",
        process: "ViewNet",
        workspace: "admin",
    },
    "/editcc2ctt/:id": {
        template: "<ixa-cc-to-ctt></ixa-cc-to-ctt>",
        process: "EditControlStructure",
        workspace: "admin",
    },
    "/ctulist": {
        template: "<ixa-ctu-list></ixa-ctu-list>",
        process: "ViewCtu",
        workspace: "admin",
    },
    "/cttlist": {
        template: "<ixa-ctt-list></ixa-ctt-list>",
        process: "ViewCtt",
        workspace: "admin",
    },
    "/prjlist": {
        template: "<ixa-prj-list></ixa-prj-list>",
        process: "ViewPrj",
        workspace: "admin",
    },
    "/crdlist": {
        template: "<ixa-crd-list></ixa-crd-list>",
        process: "ViewCrd",
        workspace: "admin",
    },
    "/psplist": {
        template: "<ixa-psp-list></ixa-psp-list>",
        process: "ViewPsp",
        workspace: "admin",
    },
    "/ctrlalist": {
        template: "<ixa-ctrla-list></ixa-ctrla-list>",
        process: "ViewCtrlA",
        workspace: "admin",
    },
    "/ctrlblist": {
        template: "<ixa-ctrlb-list></ixa-ctrlb-list>",
        process: "ViewCtrlB",
        workspace: "admin",
    },
    "/ctrlclist": {
        template: "<ixa-ctrlc-list></ixa-ctrlc-list>",
        process: "ViewCtrlC",
        workspace: "admin",
    },
    "/ctrldlist": {
        template: "<ixa-ctrld-list></ixa-ctrld-list>",
        process: "ViewCtrlD",
        workspace: "admin",
    },
    "/asnlist": {
        template: "<ixa-asn-list></ixa-asn-list>",
        process: "ViewAsn",
        workspace: "admin",
    },
    "/inolist": {
        template: "<ixa-ino-list></ixa-ino-list>",
        process: "ViewIno",
        workspace: "admin",
    },
    "/loclist": {
        template: "<ixa-loc-list></ixa-loc-list>",
        process: "ViewLoc",
        workspace: "admin",
    },
    "/actlist": {
        template: "<ixa-act-list></ixa-act-list>",
        process: "ViewAct",
        workspace: "admin",
    },
    "/netlist": {
        template: "<ixa-net-list></ixa-net-list>",
        process: "ViewNet",
        workspace: "admin",
    },
    "/cc2cttlist": {
        template: "<ixa-cc-to-ctt-list></ixa-cc-to-ctt-list>",
        process: "EditControlStructure",
        workspace: "admin",
    },
    "/ctutypelist": {
        template: '<ixa-ctutypelist></ixa-ctutypelist>',
        process: 'EditControlStructure',
        workspace: 'admin'
    },
    "/ctutypedialog/:id":{
        template: '<ixa-ctutypedialog></ixa-ctutypedialog>',
        process: 'EditControlStructure',
        workspace: 'admin'
    },
});
